import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";

function Cell(props: Props) {
  return (
    <div className={styles.cell}>
      <p className={styles.value}>
        {props.period.load.toLocaleString(props.locale)}
      </p>
    </div>
  );
}

export { Cell };
